exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-37e806e0] {\n    width: 100%;\n    display: flex;\n    color:black;\n    font-size: 16px;\n    letter-spacing: .05em;\n    gap:44px;\n}\n.contacts[data-v-37e806e0] {\n    flex-direction: column;\n    gap:0px;\n}\n.contacts p[data-v-37e806e0] {\n    margin: 0px 20px;\n}\n.contacts hr[data-v-37e806e0] {\n    background:black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37e806e0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/Contact.vue
// module id = 473
// module chunks = 0